// import Index from "@/pages/Index";
// import Login from "@/pages/Login";
// import Djgz from "@/pages/Djgz";

/*const home = () => {
    return import('@/pages/Index');
}*/
// import Details from '@/pages/Details'

export default [
    {
        path: '/details',
        component: () => import('@/pages/Details'), //懒加载，更加高效
        // component: Details, //懒加载，更加高效
        name: 'details',
        meta: {title: '详情'}
    },
    {
        path: '/search',
        component: () => import('@/pages/Search'), //懒加载，更加高效
        // component: Details, //懒加载，更加高效
        name: 'details',
        meta: {title: '详情'}
    },
    {
        path: '/radio',
        component: () => import('@/pages/Radio'), //懒加载，更加高效
        name: 'radio',
        meta: {title: '无线电科普知识宣传专栏'}
    },
    {
        path: '/details_radio',
        component: () => import('@/pages/Radio/Details'), //懒加载，更加高效
        name: 'details_radio',
        meta: {title: '无线电科普知识宣传专栏详情'}
    },
    {
        path: '/radio_list',
        component: () => import('@/pages/Radio/List'), //懒加载，更加高效
        name: 'radio_list',
        meta: {title: '无线电科普知识宣传专栏列表'}
    },
]

